import axios from "axios";
import {MS_API_URL} from "../../utilities/Constants";
import {consoleLog, captureExceptionAndSendToSentry} from "../../utilities/helpers";

export function postMSRequest(action, payload, authToken, success, error) {
    payload["token"] = authToken;
    let params = {
        'p': {
            'x': action,
            'pl': payload
        }
    };

    axios({
        url: MS_API_URL,
        data: params,
        withCredentials: true,
        method: "post"
    })
    .then(function (response) {
        if(response.data.st === "1" || response.data.st === 1) {
            if(typeof success === "function") {
                success(response.data.d);
            }
        } else {
            if(typeof error === "function") {
                error(response.data.er);
            }
        }
    })
    .catch(function (err) {
        consoleLog("MS n/w error", err);
        if(typeof error === "function") {
            error("Network Error");
        }
        captureExceptionAndSendToSentry(error, "Network Error", action);
    })
}

export function getMSData(action, payload, authToken, success, error) {
    payload["token"] = authToken;
    let params = {
        'p': {
            'x': action,
            'pl': payload
        }
    };
    axios.get(MS_API_URL, {
        params: params,
        withCredentials: true
    })
    .then(function (response) {
        if(response.data.st === "1" || response.data.st === 1) {
            if(typeof success === "function") {
                success(response.data.d);
            }
        } else {
            if(typeof error === "function") {
                error(response.data.er);
            }
        }
    })
    .catch(function (err) {
        consoleLog("MS n/w error", err);
        if(typeof error === "function") {
            error("Network Error");
        }
        captureExceptionAndSendToSentry(error, "Network Error", action);
    })
}

export function getExternalUrlData(url, success, error){
    axios({
      url: url,
      method: "get"
    })
      .then(function (response) {
        if(response.data && response.status < 400) {
          if(typeof success === "function") {
            success(response.data);
          }
        } else {
          if(typeof error === "function") {
            error(response.data);
          }
        }
      })
      .catch(function (err) {
        if(typeof error === "function") {
            error("Network Error");
        }
        captureExceptionAndSendToSentry(error, "Network Error", 'getExternalUrlData');
      })
  }